const venusQuiz = [ 
    {
    question: "Venus adalah planet ke berapa dari Matahari?",
    options: ["1", "2", "3", "4"],
    answer: 1,
  },
  {
    question: "Venus sering disebut sebagai planet kembaran Bumi karena?",
    options: [
      "Warnanya sama",
      "Ukurannya hampir sama dengan Bumi",
      "Memiliki air",
      "Memiliki kehidupan",
    ],
    answer: 1,
  },
  {
    question: "Mengapa Venus menjadi planet terpanas di tata surya?",
    options: [
      "Karena paling dekat dengan Matahari",
      "Karena efek rumah kaca yang sangat kuat",
      "Karena memiliki banyak gunung api",
      "Karena berwarna merah",
    ],
    answer: 1,
  },
  {
    question: "Atmosfer Venus sebagian besar tersusun dari?",
    options: [
      "Oksigen",
      "Nitrogen",
      "Karbon dioksida",
      "Hidrogen",
    ],
    answer: 2,
  },
  {
    question: "Arah rotasi Venus bagaimana dibandingkan planet lain?",
    options: [
      "Sama seperti Bumi",
      "Lebih cepat",
      "Berlawanan arah",
      "Tidak berotasi",
    ],
    answer: 2,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Venus?",
    options: ["0", "1", "2", "4"],
    answer: 0,
  },
  {
    question: "Permukaan Venus sebagian besar terdiri dari?",
    options: [
      "Lautan air",
      "Es",
      "Gunung api dan dataran berbatu",
      "Pasir",
    ],
    answer: 2,
  },
  {
    question: "Satu hari di Venus (rotasi) lebih lama dari?",
    options: [
      "Satu hari di Bumi",
      "Satu bulan di Bumi",
      "Satu tahun di Venus",
      "Satu minggu di Venus",
    ],
    answer: 2,
  },
  {
    question: "Warna dominan Venus saat dilihat dari luar angkasa adalah?",
    options: [
      "Biru",
      "Putih kekuningan",
      "Merah",
      "Hijau",
    ],
    answer: 1,
  },
  {
    question: "Mengapa Venus sulit diteliti langsung dari permukaannya?",
    options: [
      "Karena sangat dingin",
      "Karena gravitasinya kecil",
      "Karena suhu dan tekanan ekstrem",
      "Karena terlalu kecil",
    ],
    answer: 2,
  },
]

export default venusQuiz;